export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/modules/prices/getters.js